import React from "react";
import "../KVKK/KVKK.css";

const KullaniciSozlesmesi = () => {
  return (
    <div className="kvkk-page">
      <section className="kvkk-hero">
        <h1>Kullanıcı <span>Sözleşmesi</span></h1>
      </section>

      <div className="kvkk-content">
        <div className="kvkk-container">
          <div className="kvkk-meta">
            <table className="kvkk-info-table">
              <tbody>
                <tr><td>Unvanı</td><td>LİNGİFY SAĞLIK TEKNOLOJİLERİ ANONİM ŞİRKETİ</td></tr>
                <tr><td>Adresi</td><td>REŞİTPAŞA MAH. KATAR CAD. İTÜ ARI TEKNOKENT 3 BİNASI NO: 4 İÇ KAPI NO: B204 SARIYER / İSTANBUL</td></tr>
                <tr><td>MERSİS</td><td>0608171176500001</td></tr>
                <tr><td>E-posta</td><td>info@lingify.co</td></tr>
              </tbody>
            </table>
          </div>

          <p>Son güncelleme: 06 Nisan 2026</p>

          <h2>1. Taraflar ve Kapsam</h2>
          <p>Bu Kullanıcı Sözleşmesi ("Sözleşme"), Lingify Sağlık Teknolojileri Anonim Şirketi ("Lingify") tarafından www.lingify.co adresi üzerinden sunulan hizmetlerin kullanım şartlarını düzenlemektedir. Siteyi kullanarak bu sözleşmeyi kabul etmiş sayılırsınız.</p>

          <h2>2. Hizmet Tanımı</h2>
          <p>Lingify, nörojenik dil ve konuşma bozuklukları alanında yapay zeka destekli terapi sistemi sunan bir sağlık teknolojisi platformudur. Hizmetlerimiz şunları kapsar:</p>
          <ul>
            <li>Dil ve konuşma terapisi uygulamaları</li>
            <li>Brodmann 44 topluluk etkinlikleri ve içerikleri</li>
            <li>Blog, bülten ve bilgilendirme içerikleri</li>
            <li>İletişim ve başvuru formları</li>
          </ul>

          <h2>3. Kullanıcı Yükümlülükleri</h2>
          <ul>
            <li>Doğru ve güncel bilgi sağlamakla yükümlüsünüz.</li>
            <li>Siteyi yalnızca yasal amaçlarla kullanabilirsiniz.</li>
            <li>Başka kullanıcıların haklarını ihlal eden içerik paylaşamazsınız.</li>
            <li>Siteye yetkisiz erişim sağlamaya çalışamazsınız.</li>
            <li>Zararlı yazılım veya kod yükleyemezsiniz.</li>
          </ul>

          <h2>4. Fikri Mülkiyet</h2>
          <p>Lingify web sitesindeki tüm içerikler (metin, görsel, logo, yazılım, tasarım) Lingify'ın mülkiyetindedir ve Türk Fikri Mülkiyet Hukuku kapsamında korunmaktadır. İzinsiz kopyalama, dağıtma veya değiştirme yasaktır.</p>

          <h2>5. Sağlık Uyarısı</h2>
          <p className="kvkk-note"><strong>Önemli:</strong> Lingify platformu, profesyonel tıbbi tanı veya tedavi yerine geçmez. Platform üzerindeki içerikler bilgilendirme amaçlıdır. Sağlık sorunlarınız için mutlaka uzman bir sağlık profesyoneline başvurunuz.</p>

          <h2>6. Sorumluluk Sınırlaması</h2>
          <ul>
            <li>Lingify, hizmetlerin kesintisiz veya hatasız olacağını garanti etmez.</li>
            <li>Teknik arızalar, bakım çalışmaları veya mücbir sebeplerden kaynaklanan erişim sorunlarından sorumlu değildir.</li>
            <li>Kullanıcıların site üzerinden paylaştığı bilgilerin doğruluğundan Lingify sorumlu tutulamaz.</li>
          </ul>

          <h2>7. Topluluk Kuralları (Brodmann 44)</h2>
          <p>Brodmann 44 topluluğuna katılan kullanıcılar:</p>
          <ul>
            <li>Saygılı ve yapıcı iletişim kurmayı kabul eder.</li>
            <li>Diğer katılımcıların kişisel bilgilerini izinsiz paylaşmaz.</li>
            <li>Ticari reklam veya spam içerik paylaşmaz.</li>
            <li>Topluluk yöneticilerinin kararlarına uyar.</li>
          </ul>

          <h2>8. Hesap Sonlandırma</h2>
          <p>Lingify, bu sözleşmeyi ihlal eden kullanıcıların erişimini önceden bildirimde bulunmaksızın kısıtlama veya sonlandırma hakkını saklı tutar.</p>

          <h2>9. Uygulanacak Hukuk ve Uyuşmazlık</h2>
          <p>Bu sözleşme Türkiye Cumhuriyeti kanunlarına tabidir. Uyuşmazlıklarda İstanbul Mahkemeleri ve İcra Daireleri yetkilidir.</p>

          <h2>10. Değişiklikler</h2>
          <p>Lingify, bu sözleşmeyi önceden bildirimde bulunarak değiştirme hakkını saklı tutar. Güncellemeler yayınlandığı tarihte yürürlüğe girer.</p>

          <h2>11. İletişim</h2>
          <p>Sözleşme ile ilgili sorularınız için:</p>
          <ul>
            <li>E-posta: <a href="mailto:info@lingify.co">info@lingify.co</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default KullaniciSozlesmesi;
